export function generateContentId(data) {
    if (isSectionBried(data)) {
        return {
            ceType: data.ceType,
            ceTypeAlias: data.id,
        };
    }
    return {
        ceType: data,
        ceTypeAlias: null,
    };
}
function isSectionBried(data) {
    return data && data.hasOwnProperty('id') && data.hasOwnProperty('ceType');
}
//# sourceMappingURL=contentId.js.map